import React, { useEffect, useState } from "react";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";
import { showError, showSuccess } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";

function Account() {
  useAlphabeticInput();
  useNumericInput();

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    phone: "",
    firstName: "",
    lastName: "",
    email: "",
  });

  useEffect(() => {
    fetchMyDetails();
  }, []);

  const fetchMyDetails = async () => {
    const res = await userAPI.getDetails();
    if (res.code === 200) {
      const result = res.data;

      setFormData({
        phone: result?.mobile || "",
        firstName: result?.firstName || "",
        lastName: result?.lastName || "",
        email: result?.email || "",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName) {
      newErrors.firstName = "Please Enter First Name";
    }

    if (!formData.phone) {
      newErrors.phone = "Please Enter Phone Number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await userAPI.updateDetails(formData);
      if (res.code === 200) {
        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="my-acount-content account-dashboard mb-5">
        <div className="tf-product-side-accordions">
          <div id="contact">
            <h6>Account Details</h6>
            <div className="box-ip-checkout mt-5">
              <div className="grid-2 mb_16" style={{ gap: "16px" }}>
                <div className="tf-field style-2 style-3">
                  <input
                    className="tf-field-input tf-input only-alphabets"
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                  <label className="tf-field-label" htmlFor="firstname">
                    First name
                  </label>
                  {errors.firstName && (
                    <span className="text-danger errors">
                      {errors.firstName}
                    </span>
                  )}
                </div>
                <div className="tf-field style-2 style-3">
                  <input
                    className="tf-field-input tf-input only-alphabets"
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                  <label className="tf-field-label" htmlFor="lastname">
                    Last name
                  </label>
                </div>
              </div>

              <div className="grid-2 mb_16" style={{ gap: "16px" }}>
                <fieldset className="tf-field style-2 style-3">
                  <input
                    className="tf-field-input tf-input"
                    type="email"
                    readOnly
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <label className="tf-field-label" htmlFor="city">
                    Email Address
                  </label>
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    <b>Note:</b> Email Address can't be changed.
                  </span>
                </fieldset>
                <fieldset className="tf-field style-2 style-3">
                  <input
                    className="tf-field-input tf-input only-numeric"
                    type="text"
                    name="phone"
                    value={formData.phone}
                    maxLength={10}
                    onChange={handleChange}
                  />
                  <label className="tf-field-label" htmlFor="city">
                    Phone Number
                  </label>
                  {errors.phone && (
                    <span className="text-danger errors">{errors.phone}</span>
                  )}
                </fieldset>
              </div>

              <button
                className="shop-btn w-25"
                onClick={handleDetailsSubmit}
              >
                Update Details
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Account;
